const STYLE =
	"body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh;font-family:Roboto,Arial,sans-serif;color:#555;background:#fafafa}" +
	".box{text-align:center}" +
	".spinner{width:48px;height:48px;margin:0 auto 16px;border:5px solid #ddd;border-top-color:#1976d2;border-radius:50%;animation:spin 1s linear infinite}" +
	"@keyframes spin{to{transform:rotate(360deg)}}";

function escapeHtml(text: string): string {
	return text.replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
}

export function showReportTabLoading(reportTab: Window, title: string): void {
	reportTab.document.title = title;
	reportTab.document.body.innerHTML = `<style>${STYLE}</style><div class="box"><div class="spinner"></div><p>${escapeHtml(title)}</p></div>`;
}